import { doc, docx, pdf } from '../../../../data/constants/fileTypes/CommonMimeTypes';

export const typeOfDocumentAvailableToSignList = [doc, docx, pdf];
